import React, { createContext, useContext, useState } from "react";

// Create context for the cart
const CartContext = createContext();

export const useCart = () => useContext(CartContext); // Custom hook to use context

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState(() => {
    try {
      const savedCart = localStorage.getItem("cart");
      return savedCart ? JSON.parse(savedCart) : [];
    } catch (error) {
      console.error("Failed to load cart from local storage:", error);
      return [];
    }
  });

  const [cartDrawerOpen, setCartDrawerOpen] = useState(false);

  // Save cart to local storage whenever it changes
  React.useEffect(() => {
    try {
      localStorage.setItem("cart", JSON.stringify(cart));
    } catch (error) {
      console.error("Failed to save cart to local storage:", error);
    }
  }, [cart]);

  // Function to add an item to the cart
  const addToCart = (item) => {
    console.log("Adding item to cart:", item); // Debug log

    setCart((prevCart) => {
      const existingItemIndex = prevCart.findIndex(
        (cartItem) =>
          cartItem.id === item.id &&
          cartItem.size === item.size &&
          cartItem.color === item.color &&
          cartItem.variantId === item.variantId
      );

      if (existingItemIndex !== -1) {
        // If exact variation exists, update quantity
        const updatedCart = [...prevCart];
        updatedCart[existingItemIndex] = {
          ...updatedCart[existingItemIndex],
          quantity: updatedCart[existingItemIndex].quantity + item.quantity
        };
        return updatedCart;
      } else {
        // Add new variation
        return [...prevCart, { ...item, quantity: item.quantity || 1 }];
      }
    });
  };

  // Function to remove an item from the cart
  const removeFromCart = (itemToRemove) => {
    setCart((prevCart) => prevCart.filter((cartItem) =>
      !(cartItem.id === itemToRemove.id &&
        cartItem.size === itemToRemove.size &&
        cartItem.color === itemToRemove.color &&
        cartItem.variantId === itemToRemove.variantId)
    ));
  };

  const clearCart = () => {
    setCart([]);
    localStorage.removeItem("cart");
  };

  // Function to toggle the cart drawer visibility
  const toggleCartDrawer = () => {
    setCartDrawerOpen((prev) => !prev);
    console.log("Cart drawer state:", !cartDrawerOpen); // Debug log
  };

  return (
    <CartContext.Provider
      value={{ cart, addToCart, removeFromCart, clearCart, cartDrawerOpen, toggleCartDrawer }}
    >
      {children}
    </CartContext.Provider>
  );
};
